<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="修改业务员"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <!--内容部分 start-->
        <van-form @submit="onSubmit" ref="forms" style="margin-top: 1.5rem">
            <van-field
                    v-model="name"
                    label="业务员名称"
                    required
                    name="业务员名称"
                    clearable
                    placeholder="请输入业务员名称"
                    :rules="[{ required: true, message: '业务员名称不能为空' }]"
            />
            <van-field
                    v-model="password"
                    type="password"
                    clearable
                    label="业务员密码"
                    name="业务员密码"
                    placeholder="请输入业务员密码"

            />
            <van-field
                    v-model="tel"
                    type="tel"
                    clearable
                    required
                    label="业务员手机"
                    name="业务员手机"
                    placeholder="请输入业务员手机"
                    :rules="[{ required: true, message: '，业务员手机不能为空' }]"
            />
            <van-field
                    v-model="info"
                    rows="1"
                    clearable
                    autosize
                    label="业务员备注"
                    type="textarea"
                    placeholder="请输入备注"
            />
			<van-field
			        v-model="coupon_divide"
			        label="业务员提成比例"
			        name="业务员提成比例"
			        clearable
			        placeholder="请输入业务员提成比例"
			/>

            <van-field required name="uploader" label="业务员身份证正面"  :rules="[{ required: true, message: '，业务员身份证正面须上传' }]">
                <template #input>
                    <van-uploader  :before-delete="afterDelete" :after-read="afterRead" v-model="fileList"   multiple :max-count="1"  />
                </template>
            </van-field>

            <van-field required name="uploader" label="业务员身份证反面"   :rules="[{ required: true, message: '，业务员身份证反面须上传' }]">
                <template #input>
                    <van-uploader  :before-delete="afterDeletes" :after-read="afterReads" v-model="fileLists"  multiple :max-count="1"  />
                </template>
            </van-field>

        </van-form>
        <div style="margin: 16px;">
            <van-button @click="onSubmit" round block type="info" native-type="submit">
                确定
            </van-button>
        </div>
        <!--内容部分 end-->


    </div>
</template>

<script>
    // import VueCookie from 'vue-cookies'
    import {Notify, Toast} from 'vant';
    import Config from "../../../config";
    export default {
        name: "AgentLogin", //代理添加
        data() {
            return {
                fileList: [{url:''}],
                fileLists: [{url:''}],
                name: '',
                password: '',
                tel:'',
                info:'',
				coupon_divide:'',
                salesman_img_principal_id_card_front: '',
                salesman_img_principal_id_card_obverse:"",
                list:[],
            };
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
        created() {
            this.init()
            },
        methods: {
            init(){
                console.log(Config.baseURL)
                this.$http.get('/wechat/api.agent.salesman/getSalesman', {
                    params: {
                        salesman_id: this.$route.query.id
                    }
                }).then(response => {
                    this.name=response.data.data.name
                    this.tel=response.data.data.tel
                    this.info=response.data.data.info
                    this.coupon_divide=response.data.data.coupon_divide
                    if (response.data.data.salesman_img_principal_id_card_front){
                        this.fileList[0].url=(Config.baseURL+response.data.data.salesman_img_principal_id_card_front)
                        this.salesman_img_principal_id_card_front=response.data.data.salesman_img_principal_id_card_front
                    }else{
                        this.fileList=[]
                        this.salesman_img_principal_id_card_front=null
                    }

                    if (response.data.data.salesman_img_principal_id_card_obverse){
                        this.fileLists[0].url=(Config.baseURL+response.data.data.salesman_img_principal_id_card_obverse)
                        this.salesman_img_principal_id_card_obverse=response.data.data.salesman_img_principal_id_card_obverse
                    }else{
                        this.fileLists=[]
                        this.salesman_img_principal_id_card_obverse=null
                    }

                });
            },
            afterRead(file) {
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.salesman_img_principal_id_card_front=response.data.local_img
                        console.log(response.data.local_img)
                    }
                })
            },
            afterDelete(){
                this.salesman_img_principal_id_card_front=null
                this.fileList= []
            },
            afterReads(file) {
                this.$http.post('/wechat/api.agent.index/wechatUploadMerchantImg', {
                    localData:file.content,
                    openid: window.localStorage.getItem("openid")

                }).then(response => {
                    if (response && response.data.code== 200) {
                        this.salesman_img_principal_id_card_obverse=response.data.local_img
                    }
                })
            },
            afterDeletes(){
                this.salesman_img_principal_id_card_obverse=null
                this.fileLists= []
            },

            // 左侧返回
            onClickLeft() {
                this.$router.push("/SalesmanManagement");
                // window.history.go(-1)
            },
            // 提交
            onSubmit() {
				if(this.coupon_divide==''&&this.coupon_divide==null){
				  this.coupon_divide=0;
				}
                this.$refs.forms.validate().then(() => {
                    var toast = Toast.loading({
                        duration: 0,
                        message: '修改中',
                        forbidClick: true,
                        loadingType: 'spinner',
                    });
                    // console.log('submit', values);
                    this.$http.post('/wechat/api.agent.salesman/changeSalesman', {
                        id: this.$route.query.id,
                        name: this.name,
                        password: this.password,
                        tel:this.tel,
                        info:this.info,
                        coupon_divide:this.coupon_divide,
                        salesman_img_principal_id_card_front: this.salesman_img_principal_id_card_front,
                        salesman_img_principal_id_card_obverse:this.salesman_img_principal_id_card_obverse,
                        openid: window.localStorage.getItem("openid"),
                        status:'1'
                    }).then(response => {
                        toast.clear();
                        console.log(response.data);
                        if (response && response.data.code== 200) {

                            this.$router.push("/SalesmanManagement");
                            Notify({type: 'success', message: response.data.msg});
                            // VueCookie.set('salesmanInfo', response.data.data, 360000);
                            // window.location.href = that.redirect;

                        }else{
                            Notify({type: 'danger', message: response.data.msg});
                        }
                    })
                }).catch(() => {
                    this.$toast.fail('必填项未填写')
                })
                // window.sessionStorage.setItem("tag",this.ta)
                //  var that = this;
            },
        }
    }
</script>

<style >
    .van-icon-goods-collect-o::before{
        position: relative;
        top: 0.1rem;
    }
    .van-icon-contact::before{
        position: relative;
        top: 0.1rem;
    }

    .van-field >>>.van-field__label{
        width: 40px;
    }
</style>
